import { setOptions } from '../index'
/**
 * 请求项目地址获取
 */
// import { getData } from './api/ajax'
export class SensorsConfig {
  constructor (options = {}) {
    const { option, enableTrack } = options
    this.enableTrack = enableTrack
    this.option = option
    this.sensorsInited = false
  }

  /**
   * 修改神策配置
   * @param sensorsOption
   */
  modifySensorsConfig (sensorsOption = {}) {
    this.sensorsOption = sensorsOption
    return this
  }

  /**
   * 配置神策
   * @param deviceModel
   * @param sensorsProject
   * @param timeout
   */
  configSensors (timeout = 60000) {
    this.sensorsInited = true
    this.timeout = timeout
  }

  /**
   * 初始化配置
   * @param options {Object} 接入系统名称
   * @param enableTrack { boolean} 是否开启上报
   * @returns {SensorsConfig}
   */
  static init (option, enableTrack = true) {
    if (!option) throw new Error('缺少参数option')
    setOptions(option)
    return new SensorsConfig({ enableTrack: enableTrack === undefined ? option.runEnv === 'prod' : enableTrack, option, projectName: option.projectName })
  }
}
